<!-- src/pages/AvailablePositionsPage.vue -->
<template>
    <div>
      <AvailablePositions v-if="hasOpenings" />
      <NoPositions v-else />
    </div>
  </template>
  
  <script setup>
  import AvailablePositions from '@/pages/AvailablePosition.vue'
  import NoPositions from '@/pages/NoAvailablePosition.vue'
  
  // Later you can fetch this from Firestore or an API
  const hasOpenings = true // or false
  </script>
  